import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

import MainLoader from 'b2b-ui-components-lib/lib/components/mainLoader';

import InnerLayout from 'app-layout/inner-layout';

import { handleLead } from 'tokenGeneration/lead.handler';
import { isTMORedirect } from 'common/utils/app.utils';

import { removeUserData, saveUser, saveLeadId } from './utils';

const AuthLayout = (props) => {
  const {
    activeStep,
    multiSiteFileUploadSuccess,
    selectedRadio,
    setActiveStep,
    setSelectedRadio,
    setToast,
    toast,
    showSteps,
    setMultiSiteFileUploadSuccess,
    setNotification,
    notificationState,
    toastState,
    closeNetworkCoveragePopup,
    steps,
    isUnAuthJourney,
    toggelNotification,
    pageData,
    featureToggler
    // lob
  } = props;

  const history = useHistory();

  const isdedicatedJourney = window.location.pathname.includes('internet-leased-line');
  const [loading, setLoading] = useState(true);

  const saveUserDataFromParams = () => {
    const getParams = queryString.parse(window && window.location.search);
    const utmSource = getParams?.utm_source;
    const user = getParams?.user;
    const leadId = getParams?.leadId;

    removeUserData(utmSource);
    saveUser(user);

    if (isTMORedirect) {
      saveLeadId(leadId);
    }
  };

  useEffect(() => {
    saveUserDataFromParams();
    setLoading(true);

    handleLead(history).then((resp) => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <MainLoader />;
  }

  return (
    <InnerLayout
      isdedicatedJourney={isdedicatedJourney}
      isUnAuthJourney={isUnAuthJourney}
      activeStep={activeStep}
      multiSiteFileUploadSuccess={multiSiteFileUploadSuccess}
      selectedRadio={selectedRadio}
      setActiveStep={setActiveStep}
      setSelectedRadio={setSelectedRadio}
      setToast={setToast}
      toast={toast}
      showSteps={showSteps}
      setMultiSiteFileUploadSuccess={setMultiSiteFileUploadSuccess}
      setNotification={setNotification}
      notificationState={notificationState}
      toastState={toastState}
      closeNetworkCoveragePopup={closeNetworkCoveragePopup}
      steps={steps}
      toggelNotification={toggelNotification}
      pageData={pageData}
      featureToggler={featureToggler}
    />
  );
};

export default AuthLayout;
